import { GlobalAppState } from '@state/store';

export const getTourFilters = (state: GlobalAppState) => state.tours.tourFilters;
export const getTourFiltersAirport = (state: GlobalAppState) => state.tours.tourFilters.airport;
export const getTourFiltersAdults = (state: GlobalAppState) => state.tours.tourFilters.adults;
